<template>
  <div
    class="mode11-wrap"
    :class="[IsMobile ? 'IsMobile' : '', showStyle === 2 ? 'style2' : '']"
    v-exposure="{ eid: `101_19_${this.curindex}_0` }"
    :data-id="`101_19_${this.curindex}_0`"
    v-if="formatListjp.length > 0"
  >
    <div
      class="relative new-mode-header"
      :class="titleAlignmentClass"
      v-if="item.topLanguageMap && item.topLanguageMap?.title"
    >
      <div>
        <div class="title-left">
          <!-- <img
            class="title-icon"
            v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.icon"
            :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.icon)"
            alt
          /> -->
          <span class="title">{{ item.topLanguageMap?.title }}</span>
        </div>
        <!-- 副标题 -->
        <div class="title_sub" v-if="item.topLanguageMap?.subTitle">{{ item.topLanguageMap?.subTitle }}</div>
      </div>
    </div>

    <div
      :class="{
        mt10: IsMobile,
        mt20: !IsMobile,
        pc_style4_container: showStyle === 4,
      }"
      class="pc_style3_container jp_tupian"
      v-if="!IsMobile"
    >
      <div class="pc_style3_left" v-if="showStyle === 2">
        <img class="style2_img" :src="$utils.returnImgUrl(jpBg)" alt="" />
        <div class="style2_inner">
          <scrollNumberImg :finalValue="finalValue" :initiaValue="jpValue" :class_state="2" />
        </div>
      </div>
      <div class="pc_style3_left" v-if="showStyle === 1">
        <img class="left_img" :src="$utils.returnImgUrl(jpBg)" alt="" />
        <div class="left_inner">
          <img :src="$utils.returnImgUrl(coin.icon)" class="coin_code" alt="" srcset="" />
          <scrollNumber :finalValue="finalValue" :initiaValue="jpValue" :class_state="2" />
        </div>
      </div>
      <div
        class="pc_style3_right"
        v-if="showStyle === 1 || showStyle === 2 || showStyle === 4"
        :class="{
          pc_style4_right: showStyle === 4,
        }"
        @click="handleParentClick"
      >
        <el-row :gutter="10">
          <vue-seamless-scroll
            :data="formatListjp"
            ref="seamlessScroll"
            :class-option="classOption"
            class="no-rem_scroll-wrap"
          >
            <div class="no-rem_jp_cenent">
              <div class="jp_item" v-for="game in formatListjp" :key="game.key" :data-key="game.key">
                <!-- v-exposure="{
                    id: game.gameGroupSid,
                    eid: game.eid + game.gameGroupSid,
                    isLoop: true,
                  }"
                  :data-id="game.eid + game.gameGroupSid" -->
                <div class="jp_name-wrap">
                  <img
                    v-if="game.gamePcIcon"
                    :src="$utils.returnImgUrl(game.gamePcIcon)"
                    class="name-icon"
                    :data-key="game.key"
                    alt=""
                  />
                  <div class="name" :data-key="game.key">{{ game.userName }}</div>
                  <div class="jp_coin-wrap">
                    <div class="coin" :data-key="game.key">
                      {{ divideSymbol(game.gameRewardAmount) }}
                    </div>
                    <img
                      v-if="game.coin_icon"
                      class="coin-img"
                      :data-key="game.key"
                      :src="$utils.returnImgUrl(game.coin_icon)"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </vue-seamless-scroll>
        </el-row>
      </div>
      <!-- 样式三 -->
      <div class="pc_show_style3" v-if="showStyle === 3" @click="handleParentClick">
        <div class="pc_show_style3_top">
          <vue-seamless-scroll
            :data="formatListjp"
            ref="seamlessScroll"
            :class-option="classOption1"
            class="no-rem_scroll-wrap1"
          >
            <div class="no-rem_jp_cenent1">
              <div class="jp_item" v-for="game in formatListjp" :key="game.key" :data-key="game.key">
                <div class="jp_name-wrap">
                  <img
                    v-if="game.gamePcIcon"
                    :src="$utils.returnImgUrl(game.gamePcIcon)"
                    class="name-icon"
                    :data-key="game.key"
                    alt=""
                  />
                  <div class="game_name">
                    <div class="name" :data-key="game.key">{{ game.userName }}</div>
                    <div class="jp_coin-wrap">
                      <div class="coin" :data-key="game.key">
                        {{ divideSymbol(game.gameRewardAmount) }}
                      </div>
                      <img
                        v-if="game.coin_icon"
                        class="coin-img"
                        :data-key="game.key"
                        :src="$utils.returnImgUrl(game.coin_icon)"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vue-seamless-scroll>
          <div class="pc_show_style3_icon">
            <div class="">
              <img class="pc_show_style3_img" :src="$utils.returnImgUrl(jpBg)" alt="" />
              <div class="style2_inner style2_inner3">
                <scrollNumber :finalValue="finalValue" :initiaValue="jpValue" :class_state="2" />
              </div>
            </div>
            <vue-seamless-scroll
              :data="formatListjp2"
              ref="seamlessScroll"
              :class-option="classOption"
              class="no-rem_scroll-wrap no-rem_scroll-wrap2"
            >
              <div class="no-rem_jp_cenent">
                <div class="jp_item" v-for="game in formatListjp2" :key="game.key" :data-key="game.key">
                  <div class="jp_name-wrap">
                    <img
                      v-if="game.gamePcIcon"
                      :src="$utils.returnImgUrl(game.gamePcIcon)"
                      class="name-icon"
                      :data-key="game.key"
                      alt=""
                    />
                    <!-- <div class="name" :data-key="game.key">{{ game.userName }}</div>
                    <div class="jp_coin-wrap">
                      <div class="coin" :data-key="game.key">
                        {{ divideSymbol(game.gameRewardAmount) }}
                      </div>
                      <img
                        v-if="game.coin_icon"
                        class="coin-img"
                        :data-key="game.key"
                        :src="$utils.returnImgUrl(game.coin_icon)"
                        alt=""
                      />
                    </div> -->
                  </div>
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
          <vue-seamless-scroll
            :data="formatListjp1"
            ref="seamlessScroll"
            :class-option="classOption1"
            class="no-rem_scroll-wrap1"
          >
            <div class="no-rem_jp_cenent1">
              <div class="jp_item" v-for="game in formatListjp1" :key="game.key" :data-key="game.key">
                <div class="jp_name-wrap">
                  <img
                    v-if="game.gamePcIcon"
                    :src="$utils.returnImgUrl(game.gamePcIcon)"
                    class="name-icon"
                    :data-key="game.key"
                    alt=""
                  />
                  <div class="game_name">
                    <div class="name" :data-key="game.key">{{ game.userName }}</div>
                    <div class="jp_coin-wrap">
                      <div class="coin" :data-key="game.key">
                        {{ divideSymbol(game.gameRewardAmount) }}
                      </div>
                      <img
                        v-if="game.coin_icon"
                        class="coin-img"
                        :data-key="game.key"
                        :src="$utils.returnImgUrl(game.coin_icon)"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>

    <div
      :class="{
        mt10: IsMobile,
        mt20: !IsMobile,
        'h5_style4_container jp_tupian': showStyle === 4,
      }"
      class="h5_style3_container"
      v-if="IsMobile"
    >
      <div class="h5_style3_left" v-if="showStyle === 2">
        <img class="style2_img" :src="$utils.returnImgUrl(jpBg)" alt="" />
        <div class="style2_inner">
          <scrollNumberImg :finalValue="finalValue" :initiaValue="jpValue" :class_state="2" />
        </div>
      </div>
      <div class="h5_style3_left" v-if="showStyle === 1">
        <img style="width: 100%" :src="$utils.returnImgUrl(jpBg)" alt="" />
        <div class="h5_jp_PrizePool h5_jp_PrizePool1">
          <img :src="$utils.returnImgUrl(coin.icon)" class="coin_code" alt="" srcset="" />
          <scrollNumber :finalValue="finalValue" :initiaValue="jpValue" :class_state="2" />
        </div>
      </div>
      <el-row :gutter="10" v-if="showStyle === 4">
        <div class="scrollWrap" @click="handleParentClick">
          <vue-seamless-scroll
            :data="formatListjp"
            ref="seamlessScroll"
            :class-option="classOption"
            class="no-rem_scroll-wrap"
          >
            <div class="no-rem_jp_cenent">
              <div class="jp_item" v-for="game in formatListjp" :key="game.key" :data-key="game.key">
                <!-- v-exposure="{
                    id: game.gameGroupSid,
                    eid: game.eid + game.gameGroupSid,
                    isLoop: true,
                  }"
                  :data-id="game.eid + game.gameGroupSid" -->
                <div class="jp_name-wrap">
                  <img
                    v-if="game.gamePcIcon"
                    :src="$utils.returnImgUrl(game.gamePcIcon)"
                    class="name-icon"
                    :data-key="game.key"
                    alt=""
                  />
                  <div class="name" :data-key="game.key">{{ game.userName }}</div>
                  <div class="jp_coin-wrap">
                    <div class="coin" :data-key="game.key">
                      {{ divideSymbol(game.gameRewardAmount) }}
                    </div>
                    <img
                      v-if="game.coin_icon"
                      class="coin-img"
                      :data-key="game.key"
                      :src="$utils.returnImgUrl(game.coin_icon)"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
      </el-row>
      <el-row class="h5_jp_tupian" :gutter="10" v-if="showStyle === 1 || showStyle === 2">
        <div class="scrollWrap" @click="handleParentClick">
          <vue-seamless-scroll
            :data="formatList"
            ref="seamlessScroll"
            :class-option="classOptionH5"
            class="no-rem_scroll-wrap height58"
          >
            <div class="no-rem_jp_cenent">
              <div class="jp_item" v-for="game in formatList" :key="game.key" :data-key="game.key">
                <div class="jp_name-wrap" :data-key="game.key">
                  <img
                    v-if="game.gameH5Icon"
                    :data-key="game.key"
                    :src="$utils.returnImgUrl(game.gameH5Icon)"
                    class="name-icon"
                    alt=""
                  />
                  <div class="name" :data-key="game.key">{{ game.userName }}</div>
                </div>
                <div class="jp_coin-wrap" :data-key="game.key">
                  <div class="coin" :data-key="game.key">{{ divideSymbol(game.gameRewardAmount) }}</div>
                  <img
                    v-if="game.coin_icon"
                    class="coin-img"
                    :data-key="game.key"
                    :src="$utils.returnImgUrl(game.coin_icon)"
                    alt=""
                  />
                  <!-- <div style="margin-left: 5px;  padding-right: 4px;"> <span class="el-icon-arrow-right"></span></div> -->
                </div>
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
      </el-row>

      <div class="jp_tupian" v-if="showStyle === 3" @click="handleParentClick">
        <div class="h5_style3_left h5_style3_left3">
          <img style="width: 80%" :src="$utils.returnImgUrl(jpBg)" alt="" />
          <div class="h5_jp_PrizePool h5_jp_PrizePool3">
            <img :src="$utils.returnImgUrl(coin.icon)" class="coin_code" alt="" srcset="" />
            <scrollNumber :finalValue="finalValue" :initiaValue="jpValue" :class_state="2" />
          </div>
        </div>
        <vue-seamless-scroll
          :data="formatListjp"
          ref="seamlessScroll"
          :class-option="classOption"
          class="no-rem_scroll-wrap height110"
        >
          <div class="no-rem_jp_cenent">
            <div class="jp_item jp_item3" v-for="game in formatListjp" :key="game.key" :data-key="game.key">
              <div class="jp_name-wrap">
                <img
                  v-if="game.gamePcIcon"
                  :src="$utils.returnImgUrl(game.gamePcIcon)"
                  class="name-icon"
                  :data-key="game.key"
                  alt=""
                />
                <div class="name" :data-key="game.key">{{ game.userName }}</div>
                <div class="jp_coin-wrap">
                  <div class="coin" :data-key="game.key">
                    {{ divideSymbol(game.gameRewardAmount) }}
                  </div>
                  <img
                    v-if="game.coin_icon"
                    class="coin-img"
                    :data-key="game.key"
                    :src="$utils.returnImgUrl(game.coin_icon)"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
    <!-- 跳转游戏 -->
    <jpDetailDialog ref="jpDetailDialog" />
  </div>
</template>
<script>
import mode11 from "@/lobby_common/mixins_views/homeModule/mode11.js";
import scrollNumber from "@/lobby_common/mixins_components/scrollNumber/index.vue";
import scrollNumberImg from "@/lobby_common/mixins_components/scrollNumber/jp.vue";
import jpDetailDialog from "./jpDetailDialog.vue";

export default {
  mixins: [mode11],
  components: {
    scrollNumber,
    scrollNumberImg,
    jpDetailDialog,
  },
};
</script>
<style lang="scss" scoped>
.h5_style3_left3 {
  padding: 0 !important;
}
.mode11-wrap {
  padding: 10px 0;
  background: var(--background-1800);
  text-align: center;
  box-sizing: border-box;
  border-radius: 5px;
  @media (max-width: 768px) {
    padding: 5px 8px 8px;
    border-radius: 0;
    margin-top: 10px;
  }
  &.IsMobile.style2 {
    padding: 0px 8px 8px;
  }
  .title {
    font-size: 32px;
    // color: var(--font-color-100);
    // font-weight: bold;
    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
  ::v-deep .scroll-number {
    font-size: 28px;
    // color: var(--font-color-1200);
    @media (max-width: 768px) {
      font-size: 22px;
    }
  }
  .jpValue {
    margin-top: 5px;
    width: 100%;
    background-color: var(--background-300);
    border-radius: 5px;
    .jpValue-wrap {
      padding-top: 10px;
      display: inline-flex;
      align-items: center;
      margin: 0 auto;
      .coin_code {
        margin-right: 5px;
        width: 30px;
        height: 30px;
        @media (max-width: 768px) {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .jp-scroll {
    margin-top: 10px;
  }
  .item-wrap {
    padding-bottom: 10px;
    overflow: hidden;
    &.middle {
      position: relative;
      &::after,
      &::before {
        position: absolute;
        content: "";
        top: 50%;
        height: 80%;
        transform: translateY(-50%);
        width: 2px;
        background: var(--border-color-200);
      }
      &::before {
        left: 0;
      }
      &::after {
        right: 0;
        @media (max-width: 768px) {
          display: none;
        }
      }
    }
    &-mobile {
      padding: 0 10px;
      margin-bottom: 0;
    }
    .item {
      padding: 5px 40px;
      display: flex;
      justify-content: space-between;
      @media (max-width: 768px) {
        padding: 5px;
      }
      .name-wrap {
        font-size: 14px;
        display: flex;
        align-items: center;
        @media (max-width: 768px) {
          font-size: 12px;
        }
        .name-icon {
          width: 20px;
          height: 23px;
          border-radius: 5px;
        }
        .name {
          padding-left: 4px;
          color: var(--font-color-900);
        }
      }
      .coin-wrap {
        display: flex;
        align-items: center;
        font-size: 14px;
        @media (max-width: 768px) {
          font-size: 12px;
        }
        .coin {
          padding-right: 4px;
          color: var(--font-color-1000);
        }
        .coin-img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}
.no-rem_scroll-wrap {
  position: relative;
  overflow: hidden;
  width: 100%;
}
.height58 {
  height: 58px;
}
.height110 {
  height: 110px;
  margin-top: 20px;
  .name-icon {
    height: 110px !important;
  }
}
.pointer {
  cursor: pointer;
}

.pc_style3 {
  &_container {
    display: flex;
    align-items: center;
  }
  &_left {
    padding: 0 20px 0 30px;
    position: relative;
    width: 385px;
    height: 115px;
    .style2_img {
      width: 385px;
      height: 48px;
    }
    .style2_inner {
      margin-top: 14px;
    }
    .left_img {
      width: 385px;
      height: 115px;
    }
    .left_inner {
      position: absolute;
      bottom: 15px;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      .coin_code {
        margin-right: 6px;
        width: 32px;
        height: 32px;
      }
      ::v-deep .scroll-number {
        font-size: 32px;
        line-height: 40px;
      }
    }
  }
  &_right {
    flex: 1;
    overflow: hidden;
  }
}
.pc_style4_container {
  &.jp_tupian {
    .jp_item {
      width: 124px;
      overflow: hidden;

      .jp_name-wrap {
        width: 110px;
        img {
          width: 110px;
          height: 150px;
        }
      }
    }
  }
}
.h5_style4_container {
  &.jp_tupian {
    .jp_item {
      width: 87px;
      overflow: hidden;

      .jp_name-wrap {
        margin: 0 6px;
        width: 75px;
        img {
          width: 75px;
          height: 88px;
        }
      }
    }
  }
}
.h5_style3 {
  // &_container {
  //   &.h5_jp_tupian {
  //     .no-rem_jp_cenent {
  //       // height: auto;
  //     }
  //   }
  // }
  &_left {
    position: relative;
    padding: 8px 0 4px;
    .style2_img {
      width: 216px;
      height: 27px;
    }
    .style2_inner {
      margin-top: 6px;
    }
    .h5_jp_PrizePool {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      // top: unset;
      // left: 50%;
      // transform: translateX(-50%);
      // bottom: 14px;
      .coin_code {
        margin-right: 4px;
        // margin-bottom: 2px;
        width: 22px;
        height: 22px;
      }
    }
  }
}
.jp_tupian {
  width: 100%;

  .jp_img {
    position: relative;

    img {
      min-height: 120px;
    }
  }

  .jp_PrizePool {
    position: absolute;
    top: 46%;
    left: 50%;
    transform: translate(-50%, 0%);
  }

  .no-rem_jp_cenent {
    display: flex;
    box-sizing: border-box;
    align-items: center;
    overflow: hidden;
  }

  .jp_item {
    width: 84px;
    display: inline-block;
    cursor: pointer;

    .jp_name-wrap {
      margin: 0 12px;
      width: 80px;
      overflow: hidden;
      font-size: 12px;

      .jp_coin-wrap {
        display: flex;
        overflow: hidden;
        box-sizing: border-box;
        text-overflow: unset;
        white-space: unset;
        justify-content: center;
        align-items: center;

        .name {
          color: var(--font-color-900);
        }

        .coin {
          max-width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: var(--font-color-1000);
        }

        .coin-img {
          display: inline-block;
          width: 15px;
          height: 15px;
        }
      }

      .name {
        display: block;
        padding: 5px 0px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--font-color-900);
      }
      .name-icon {
        box-shadow: var(--boxShadow-600);
      }
      img {
        width: 80px;
        height: 80px;
        border-radius: var(--radius-301);
        // margin: 0 0 0 4px;
        display: block;
        /* 避免 img 元素底部的空隙 */
      }
    }
  }
}

.h5_jp_tupian {
  // margin: 10px 0px;

  .jp_img {
    position: relative;

    img {
      min-height: 82px;
    }
  }

  .h5_jp_PrizePool {
    position: absolute;
    top: 53%;
    left: 50%;
    transform: translate(-50%, 0%);
  }

  .no-rem_jp_cenent {
    // height: 120px;
    padding: 0 15px 0;
    box-sizing: border-box;
    overflow: hidden;

    .jp_item {
      display: flex;
      box-sizing: border-box;
      align-items: center;
      cursor: pointer;
      font-size: 12px;

      .jp_name-wrap {
        margin: 6px 10px 6px 0;
        display: flex;
        align-items: center;

        .name {
          max-width: 200px;
          display: block;
          margin: 0px 5px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
          color: var(--font-color-900);
        }

        img {
          width: 17px;
          height: 17px;
          border-radius: 3px;
          display: block;
          /* 避免 img 元素底部的空隙 */
        }
      }

      .jp_coin-wrap {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        justify-content: flex-end;
        margin-left: auto;

        .coin {
          width: 100px;
          margin-right: 5px;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: var(--font-color-1000);
        }

        .coin-img {
          display: inline-block;
          width: 14px;
          height: 14px;
          // margin-right: 10px;
        }
      }
    }
  }
}
.pc_show_style3 {
  width: 100%;
  .pc_show_style3_top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 500px;
    overflow: hidden;
    .no-rem_scroll-wrap1 {
      width: 290px;
      height: 400px;
      margin-top: 100px;
      overflow: hidden;
      .jp_item {
        width: 290px;
      }
      .jp_name-wrap {
        width: 290px;
        margin: 0 0 12px 0;
        display: flex;
        font-size: 16px;
        .name-icon {
          width: 110px;
          height: 150px;
          border-radius: 10px 0 0 10px;
        }
        .game_name {
          padding: 0 10px;
          width: 160px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: start;
          background-image: url("~@/assets/home/modeBg.png");
          background-size: 100% 100%;
          .jp_coin-wrap {
            margin-top: 20px;
          }
        }
      }
    }
    .pc_show_style3_icon {
      display: flex;
      flex-direction: column;
      width: 40%;
      justify-content: space-between;
      .pc_show_style3_img {
        display: block;
        width: 100%;
      }
    }
  }

  .no-rem_scroll-wrap2 {
    .jp_item {
      width: 170px;
    }
    .jp_name-wrap {
      width: 150px;
      .name-icon {
        width: 150px;
        height: auto;
      }
    }
  }
}
.style2_inner3 {
  margin-top: -50px !important;
}
.h5_jp_PrizePool3 {
  margin: -37px 0 0px 0 !important;
}
.h5_jp_PrizePool1 {
  position: absolute !important;
  top: 48%;
  left: 50%;
  transform: translate(-50%);
  bottom: 14px;
}

.jp_item3 {
  width: 60px !important;
  .name-icon {
    width: 54px !important;
    height: 76px !important;
  }
  .jp_name-wrap {
    width: 60px !important;
    font-size: 10px !important;
    padding: 0 0.3rem !important;
  }
}
</style>
